import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardActions,
  Button,
  Typography,
  List,
  ListItem,
  Divider,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import CartItemActions from "./CartItemActions";
import DealChip from "./DealChip";
import EmptyCartMessage from "./EmptyCartMessage";

import {
  getUnitPrice,
  getProductDeal,
  calculateItemTotal,
  calculateCartTotal,
} from "../helpers/cartPriceHelper";

const COLOR_MAP = {
  שחור: "#000000",
  לבן: "#FFFFFF",
  אדום: "#E53935",
  כחול: "#1E88E5",
  תכלת: "#4FC3F7",
  ירוק: "#43A047",
  צהוב: "#FDD835",
  כתום: "#FB8C00",
  ורוד: "#D81B60",
  סגול: "#8E24AA",
  חום: "#6D4C41",
  אפור: "#757575",
  זהב: "#C9A227",
  כסף: "#B0BEC5",
};

const accessibleButtonStyle = {
  minHeight: 44,
  px: 3,
  fontWeight: 600,
  backgroundColor: "#D81B60",

  "&:hover": {
    backgroundColor: "#AD1457",
  },

  "&:focus-visible": {
    outline: "3px solid #111",
    outlineOffset: "3px",
  },
};

const Cart = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const cart = useSelector((state) => state.cart.items || []);
  const loggedUser = useSelector(
    (state) => state.user.logedUser
  );

  const total = calculateCartTotal(cart);

  const API_BASE =
    process.env.REACT_APP_API_BASE_URL || "";

  const resolveImgSrc = (img) => {
    if (!img) {
      return null;
    }

    if (img instanceof File) {
      return URL.createObjectURL(img);
    }

    const path = String(img).replace(/\\/g, "/");

    if (
      path.startsWith("http://") ||
      path.startsWith("https://") ||
      path.startsWith("//")
    ) {
      return path;
    }

    return `${API_BASE}${path}`;
  };

  const handleContinueShopping = () => {
    if (location.state?.from === "/signIn") {
      navigate("/");
      return;
    }

    /*
      במקרה שאין היסטוריית ניווט קודמת,
      עדיף לעבור ישירות לעמוד המוצרים.
    */
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/products");
    }
  };

  const handleCheckoutClick = () => {
    if (loggedUser) {
      navigate("/CheckoutSummary");
      return;
    }

    navigate("/signIn", {
      state: {
        from: "/CheckoutSummary",
      },
    });
  };

  return (
    <Box
      component="main"
      dir="rtl"
      aria-labelledby="cart-page-title"
      sx={{
        width: "100%",
        px: {
          xs: 1.5,
          sm: 2,
        },
        py: 2,
      }}
    >
      <Card
        component="section"
        aria-labelledby="cart-page-title"
        sx={{
          maxWidth: 950,
          width: "100%",
          mx: "auto",
          borderRadius: 2,
          overflow: "visible",
        }}
      >
        <CardContent
          sx={{
            p: {
              xs: 2,
              sm: 3,
            },
          }}
        >
          <Typography
            id="cart-page-title"
            component="h1"
            sx={{
              fontSize: {
                xs: "1.5rem",
                sm: "1.75rem",
              },
              fontWeight: 700,
              color: "#D81B60",
              mb: 3,
            }}
          >
            סל קניות
          </Typography>

          {cart.length === 0 ? (
            <Box
              role="status"
              aria-live="polite"
              sx={{ py: 2 }}
            >
              <EmptyCartMessage />
            </Box>
          ) : (
            <List
              aria-label={`מוצרים בסל הקניות, ${cart.length} פריטים`}
              disablePadding
            >
             {cart.map((item, index) => {
  const product = item?.product;

  console.log("שם מוצר:", product?.name);

  console.log("מבצעים:", {
    productDeals: product?.productDeals,
    ProductDeals: product?.ProductDeals,
    deals: product?.deals,
    Deals: product?.Deals,
  });

  console.log(
    "מבצע שנמצא:",
    getProductDeal(product)
  );

  console.log(
    "מחיר אחרי מבצע:",
    calculateItemTotal(item)
  );

  const productName =
    product?.name || "מוצר ללא שם";

                const displayImage =
                  item?.productOption?.image ||
                  product?.image;

                const imageSrc =
                  resolveImgSrc(displayImage);

                const unitPrice =
                  getUnitPrice(item);

                const lineTotal =
                  calculateItemTotal(item);

                const optionType =
                  item?.productOption?.optionType;

                const optionValue =
                  item?.productOption?.value;

                const optionLabel =
                  optionType === "Color"
                    ? "צבע"
                    : "בחירה";

                const productHeadingId =
                  `cart-product-${item.id || index}`;

                const productDescriptionId =
                  `cart-product-description-${item.id || index}`;

                return (
                  <React.Fragment
                    key={
                      item.id ||
                      `${product?.id}-${optionValue}-${index}`
                    }
                  >
                    <ListItem
                      component="li"
                      alignItems="flex-start"
                      aria-labelledby={productHeadingId}
                      aria-describedby={productDescriptionId}
                      sx={{
                        px: 0,
                        py: 2.5,
                      }}
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: {
                            xs: "72px minmax(0, 1fr)",
                            sm: "80px minmax(0, 1fr)",
                            md: "80px minmax(0, 1fr) 170px 150px 100px",
                          },
                          alignItems: {
                            xs: "start",
                            md: "center",
                          },
                          columnGap: {
                            xs: 1.5,
                            sm: 2,
                          },
                          rowGap: {
                            xs: 2,
                            md: 0,
                          },
                          width: "100%",
                          direction: "rtl",
                        }}
                      >
                        {/* תמונת המוצר */}
                        {imageSrc ? (
                          <Box
                            component="img"
                            src={imageSrc}
                            alt={`תמונת המוצר ${productName}`}
                            loading="lazy"
                            sx={{
                              width: {
                                xs: 64,
                                sm: 70,
                              },
                              height: {
                                xs: 64,
                                sm: 70,
                              },
                              objectFit: "contain",
                              borderRadius: 1,
                              border: "1px solid",
                              borderColor: "divider",
                              backgroundColor:
                                "background.paper",
                            }}
                          />
                        ) : (
                          <Box
                            role="img"
                            aria-label={`אין תמונה זמינה עבור ${productName}`}
                            sx={{
                              width: {
                                xs: 64,
                                sm: 70,
                              },
                              height: {
                                xs: 64,
                                sm: 70,
                              },
                              borderRadius: 1,
                              border: "1px solid",
                              borderColor: "divider",
                              backgroundColor:
                                "grey.100",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              textAlign: "center",
                              fontSize: "0.75rem",
                              px: 0.5,
                            }}
                          >
                            אין תמונה
                          </Box>
                        )}

                        {/* שם המוצר והאפשרות */}
                        <Box
                          sx={{
                            minWidth: 0,
                            alignSelf: "stretch",
                          }}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                            }}
                          >
                            <DealChip
                              product={product}
                            />

                            <Typography
                              id={productHeadingId}
                              component="h2"
                              sx={{
                                width: "100%",
                                fontWeight: 600,
                                fontSize: {
                                  xs: "1rem",
                                  sm: "1.125rem",
                                },
                                lineHeight: 1.4,
                                mt: 0.5,
                                textAlign: "right",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                overflowWrap:
                                  "anywhere",
                              }}
                            >
                              {productName}
                            </Typography>
                          </Box>

                          <Box
                            id={productDescriptionId}
                          >
                            {item.productOption && (
                              <Typography
                                component="p"
                                sx={{
                                  fontWeight: 500,
                                  textAlign: "right",
                                  fontSize: {
                                    xs: "0.95rem",
                                    sm: "1rem",
                                  },
                                  mt: 0.5,
                                  mb: 0,
                                }}
                              >
                                {optionLabel}:{" "}
                                <Box
                                  component="span"
                                  sx={{
                                    fontWeight: 700,
                                  }}
                                >
                                  {optionValue}
                                </Box>

                                {optionType ===
                                  "Color" && (
                                  <Box
                                    component="span"
                                    aria-hidden="true"
                                    sx={{
                                      display:
                                        "inline-block",
                                      width: 18,
                                      height: 18,
                                      mr: 1,
                                      verticalAlign:
                                        "middle",
                                      borderRadius:
                                        "50%",
                                      backgroundColor:
                                        COLOR_MAP[
                                          optionValue
                                        ] ||
                                        "transparent",
                                      border:
                                        optionValue ===
                                        "לבן"
                                          ? "1px solid #777"
                                          : "1px solid rgba(0,0,0,0.25)",
                                    }}
                                  />
                                )}
                              </Typography>
                            )}
                          </Box>
                        </Box>

                        {/* כמות ומחיר ליחידה */}
                        <Typography
                          component="p"
                          aria-label={`כמות ${item.amount}, מחיר ליחידה ${unitPrice.toFixed(
                            2
                          )} שקלים`}
                          sx={{
                            gridColumn: {
                              xs: "1 / -1",
                              md: "auto",
                            },
                            minWidth: {
                              md: 140,
                            },
                            textAlign: {
                              xs: "right",
                              md: "center",
                            },
                            fontWeight: 600,
                            fontSize: {
                              xs: "1rem",
                              sm: "1.075rem",
                            },
                            m: 0,
                          }}
                        >
                          כמות: {item.amount} ×{" "}
                          <Box
                            component="span"
                            dir="ltr"
                            sx={{
                              display:
                                "inline-block",
                            }}
                          >
                            {unitPrice.toFixed(2)} ₪
                          </Box>
                        </Typography>

                        {/* סך הכול למוצר */}
                        <Typography
                          component="p"
                          aria-label={`סך הכול עבור ${productName}: ${lineTotal.toFixed(
                            2
                          )} שקלים`}
                          sx={{
                            gridColumn: {
                              xs: "1 / -1",
                              md: "auto",
                            },
                            minWidth: {
                              md: 140,
                            },
                            textAlign: {
                              xs: "right",
                              md: "center",
                            },
                            fontWeight: 700,
                            fontSize: {
                              xs: "1rem",
                              sm: "1.075rem",
                            },
                            m: 0,
                          }}
                        >
                          סה״כ:{" "}
                          <Box
                            component="span"
                            dir="ltr"
                            sx={{
                              display:
                                "inline-block",
                            }}
                          >
                            {lineTotal.toFixed(2)} ₪
                          </Box>
                        </Typography>

                        {/* פעולות שינוי כמות ומחיקה */}
                        <Box
                          aria-label={`פעולות עבור ${productName}`}
                          sx={{
                            gridColumn: {
                              xs: "1 / -1",
                              md: "auto",
                            },
                            justifySelf: {
                              xs: "stretch",
                              md: "center",
                            },
                            width: {
                              xs: "100%",
                              md: "auto",
                            },

                            /*
                              מוסיף סימון ברור לרכיבים
                              שנמצאים בתוך CartItemActions.
                            */
                            "& button:focus-visible": {
                              outline:
                                "3px solid #111",
                              outlineOffset: "3px",
                            },
                          }}
                        >
                          <CartItemActions
                            item={item}
                            product={product}
                            variant="cart"
                          />
                        </Box>
                      </Box>
                    </ListItem>

                    {index < cart.length - 1 && (
                      <Divider
                        component="li"
                        aria-hidden="true"
                      />
                    )}
                  </React.Fragment>
                );
              })}
            </List>
          )}

          {/* סה"כ לתשלום */}
          {cart.length > 0 && (
            <Box
              role="status"
              aria-live="polite"
              aria-atomic="true"
              sx={{
                display: "flex",
                justifyContent: {
                  xs: "flex-start",
                  md: "flex-end",
                },
                mt: 3,
                pt: 2,
                borderTop: "2px solid",
                borderColor: "divider",
              }}
            >
              <Typography
                component="p"
                sx={{
                  fontSize: {
                    xs: "1.2rem",
                    sm: "1.35rem",
                  },
                  fontWeight: 700,
                  m: 0,
                }}
              >
                סה״כ לתשלום:{" "}
                <Box
                  component="span"
                  dir="ltr"
                  sx={{
                    display: "inline-block",
                  }}
                >
                  {total.toFixed(2)} ₪
                </Box>
              </Typography>
            </Box>
          )}
        </CardContent>

        <CardActions
          sx={{
            px: {
              xs: 2,
              sm: 3,
            },
            pb: 3,
            pt: 1,
          }}
        >
          <Box
            aria-label="פעולות סל הקניות"
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "row",
              },
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            {cart.length > 0 ? (
              <>
                <Button
                  type="button"
                  variant="contained"
                  onClick={handleCheckoutClick}
                  aria-label={
                    loggedUser
                      ? "מעבר לעמוד השלמת ההזמנה"
                      : "התחברות לצורך מעבר לעמוד השלמת ההזמנה"
                  }
                  sx={{
                    ...accessibleButtonStyle,
                    order: {
                      xs: 1,
                      sm: 2,
                    },
                  }}
                >
                  המשך לקופה
                </Button>

                <Button
                  type="button"
                  variant="outlined"
                  onClick={handleContinueShopping}
                  sx={{
                    minHeight: 44,
                    px: 3,
                    fontWeight: 600,
                    borderColor: "#D81B60",
                    color: "#AD1457",
                    order: {
                      xs: 2,
                      sm: 1,
                    },

                    "&:hover": {
                      borderColor: "#AD1457",
                      backgroundColor:
                        "rgba(216, 27, 96, 0.08)",
                    },

                    "&:focus-visible": {
                      outline:
                        "3px solid #111",
                      outlineOffset: "3px",
                    },
                  }}
                >
                  המשך בקנייה
                </Button>
              </>
            ) : (
              <Button
                type="button"
                variant="contained"
                onClick={() =>
                  navigate("/products")
                }
                sx={accessibleButtonStyle}
              >
                התחלת קנייה
              </Button>
            )}
          </Box>
        </CardActions>
      </Card>
    </Box>
  );
};

export default Cart;